// Slugs the system needs for itself. Mirror of the server-side list in
// functions/src/slugs/reserved.js — keep both in sync.
export const RESERVED_SLUGS = new Set([
  "app", "api", "auth", "assets", "__", "admin", "about",
  "login", "signin", "signup", "dashboard", "favicon", "robots",
  "terms", "privacy", "help", "support", "static", "public",
]);

export function isReserved(slug) {
  return RESERVED_SLUGS.has(slug);
}
